<template>
  <div v-if="showItem">
    <!-- TODO: Inserire combobox: Attenzione errore non visualizza la descrizione ma il codice!! -->
    <v-autocomplete
      :disabled="disabled || item.readonly || lockItem"
      :items="esplodiTag(sourceArray)"
      item-text="descrizione"
      item-value="codice"
      :value="selectedTags"
      label="Tag"
      :rules="rulesValidation"
      :return-object="true"
      multiple
      @change="onChange"
      @click:clear="onClear"
      @focus="onFocus"
      @blur="onBlur"
      :ref="item.descrizione"
    >
      <template v-slot:prepend>
        <span v-if="item.required" class="red--text">*</span>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
/* eslint-disable */
import { dynamicSortMultiple } from "@/components/helpers.js";
import configurazioni from "@/services/configurazioniService.js";
import { validazioni } from "@/mixins/validazioni.js";

export default {
  name: "multiselectTag",
  mixins: [validazioni],
  props: {
    item: Object,
    appoggio: Object,
    disabled: { type: Boolean, default: false },
    updateTrigger: Number,
    defaultUsed: { type: Boolean, default: false },
  },
  data: (vm) => ({
    elementi: [],
    sourceArray: [],
    dialog: false,
    codice: "",
    descrizione: "",
    valoreInserito: "",
    oldValue: "",
    formAddFieldsValid: true,
    selectedTags: [], // Track selected tags (complete objects)
  }),
  async mounted() {
    if (typeof this.item.source === "string") {
      const config = this.item.source.split(".");
      const configId = config[0];
      const subId = config[1] || "";
      const sub2 = config[2] || "";
      this.sourceArray = await configurazioni.getConfigurazione(
        configId,
        subId
      );

      if (sub2) {
        this.elementi = this.sourceArray
          ? this.sourceArray
              .filter((x) => x.tipo === sub2)
              .map((x) => {
                return { codice: x.codice, descrizione: x.descrizione };
              })
          : [];
      } else {
        this.elementi = this.sourceArray ? this.sourceArray : [];
      }
    } else if (Array.isArray(this.item.source)) {
      this.elementi = [...this.item.source];
    }

    if (this.item.exclude && this.item.exclude.length > 0) {
      for (let e of this.item.exclude) {
        this.elementi = this.elementi.filter(
          (x) => !this.item.exclude.includes(x.tipoDocumento)
        );
      }
    }

    if (this.item.default && !this.defaultUsed) {
      const el = this.elementi.find((x) => x.codice === this.item.default);
      if (el) {
        this.onChange([el], null, true); // Initialize with default value
      }
    }

    // Initialize selectedTags with complete objects from this.item.value
    if (this.item.value && Array.isArray(this.item.value)) {
      this.selectedTags = this.item.value;
    }
  },
  watch: {
    updateTrigger() {
      this.$forceUpdate();
    },
  },
  computed: {
    showItem() {
      if (this.item && this.item.showIf) {
        return _.get(this, this.item.showIf, false);
      } else if (this.item && this.item.hideIf) {
        return !_.get(this, this.item.hideIf, false);
      } else {
        return true;
      }
    },
    lockItem() {
      if (this.item && this.item.lockIf) {
        return !!_.get(this, this.item.lockIf, false);
      } else {
        return false;
      }
    },
    dialogTitle() {
      return "Nuovo valore " + this.item.label;
    },
    rulesValidationAddCode() {
      let rl = [];
      rl.push(this.rules.required);
      rl.push(this.rules.nospaces);
      rl.push(this.rules.setristretto);
      return rl;
    },
    rulesValidationAddDescription() {
      let rl = [];
      rl.push(this.rules.required);
      return rl;
    },
  },
  methods: {
    onFocus(e) {
      this.oldValue = e.currentTarget.value;
    },
    onBlur(e) {
      this.valoreInserito = e.currentTarget.value;
      if (this.valoreInserito !== this.oldValue) {
        this.onChange(null, this.valoreInserito);
      }
    },
    onChange(selectedItems) {
      if (selectedItems) {
        // Remove duplicates from selectedItems
        const uniqueSelectedItems = this.removeDuplicates(selectedItems);

        // Update selectedTags with the current selection
        this.selectedTags = uniqueSelectedItems;
        // Emit the change event with the unique items
        this.$emit("change", {
          model: this.item.model,
          subModel: this.item.subModel,
          value: uniqueSelectedItems,
        });
      }
    },
    onClear() {
      // Clear selectedTags
      this.selectedTags = [];

      // Emit the change event with an empty array
      this.$emit("change", {
        model: this.item.model,
        subModel: this.item.subModel,
        value: [],
      });
      this.oldValue = "";
    },
    esplodiTag(arrayTag) {
      let risultato = [];
      function traverse(tag) {
        risultato.push({ codice: tag.codice, descrizione: tag.descrizione });
        if (tag.tags && tag.tags.length > 0) {
          tag.tags.forEach((nestedTag) => traverse(nestedTag));
        }
      }
      arrayTag.forEach((tag) => traverse(tag));
      return risultato;
    },
    removeDuplicates(array) {
      const uniqueMap = new Map();
      array.forEach((item) => {
        if (!uniqueMap.has(item.codice)) {
          uniqueMap.set(item.codice, item);
        }
      });
      return Array.from(uniqueMap.values());
    },
  },
};
</script>
